import emeter_63_monophase_settings_gen_3 from '@devices/settings/common_settings/emeter_63_monophase_settings_gen_3';
import emeter_63_triphase_settings_gen_3 from '@devices/settings/common_settings/emeter_63_triphase_settings_gen_3';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'Shelly3EM63G3',
	friendly_name: '3EM-63 Gen3',
	family: 'emeter',
	isPM: true,
	modes: {
		monophase: {
			channels: 3,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage'],
			phases: 3,
			settings: emeter_63_monophase_settings_gen_3,
		},
		triphase: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage'],
			phases: 3,
			settings: emeter_63_triphase_settings_gen_3,
		},
	},
};
